import { useMemo } from "react";
import { useCheckEstimateEditorAccess } from "@hooks";
import { useEstimateEditorStore, useEstimateStructure } from "@tools";

export const useUserVisibleWorkTypes = (taskWorkTypes, isProposal, isTimeline) => {
  
  const structure = useEstimateStructure();
  const editorStore = useEstimateEditorStore();
  
  const { apply } = structure.visibility;
  const { excludeTurnedOffElements } = structure;
  const {
    workTypesWithStatus,
    estimateUserWorkTypeVisibility
  } = editorStore;
  
  const { userId, userUuid, isObserver } = useCheckEstimateEditorAccess(editorStore.estimateUsers);
  
  return useMemo(() => {
    let wt = taskWorkTypes;
    
    if(isProposal)
      wt = taskWorkTypes.filter(wT => !(
        ((wT.isHidden || (isTimeline && wT.hideOnTimeline)) && apply) || (excludeTurnedOffElements && wT.turnOff)
      ));
    
    return (
      isObserver && editorStore.hasAssignedWorkTypes(userUuid) && estimateUserWorkTypeVisibility[userId] === 0
        ? wt.filter(({id}) => workTypesWithStatus?.find(w => w.id === id)?.estimatorUuid === userUuid)
        : wt
    );
  }, [userId, editorStore, isObserver, taskWorkTypes, workTypesWithStatus, estimateUserWorkTypeVisibility, apply, isProposal, excludeTurnedOffElements]);
}